export enum UiWidget {
  DropdownList = "Dropdown List",
  ChoiceList = "Choice List",
  ColorSwatch = "Color Swatch Tray",
  RadioButton = "Radio Button",
  CheckBox = "Check Box",
  RadioCheckCombo = "Radio / Check Combo",
}
